// noinspection JSUnresolvedReference

import Axios from "axios";

function updateCheckinCounts() {
	const totalCheckinsCountLabel = document.querySelector('.total-checkins-count')
	const totalExpectedCheckinsCountLabel = document.querySelector('.total-expected-checkins-count')

	Axios.post(window['routes/admin.checkins.get-counts'])
		.then(response => {
			const counts = response.data.counts;

			totalCheckinsCountLabel.innerHTML = counts.currentCheckinsCount;
			totalExpectedCheckinsCountLabel.innerHTML = counts.expectedCheckinsCount;
		});
}

export {updateCheckinCounts}
